<div class="modal-header">
    <h4 class="modal-title">{{ options.title }}</h4>
</div>
<div class="modal-body">
    <div [innerHTML]="options.message"></div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="yes()">
        {{ labelyes }}
    </button>
    <button type="button" class="btn btn-secondary" (click)="no()">
        {{ labelno }}
    </button>
</div>